export default "__VITE_ASSET__CYnigDSS__"